<template>
    <div>
        <hk-notice></hk-notice>
        <div class="live-list">
            <div
                v-if="liveList.length === 0 || liveList === ''"
                class="no-lesson flex flex-column flex-vertical-center flex-center"
            >
                <img src="@images/base/no-lesson.png" class="no-lesson-img" alt="" />
                <p class="no-lesson-text">暂无课程，老师正在加急上传中</p>
            </div>
            <div v-for="item in getGroupData" v-else :key="item.label" class="month-list">
                <live-list :listData="item.value" :title="item.label"></live-list>
            </div>
        </div>
    </div>
</template>

<script>
import HkNotice from '@components/HkNotice';
import LiveList from '@components/liveList/LiveList';
import moment from '@plugins/_moment';
import { mapGetters } from 'vuex';

export default {
    name: 'Home',
    components: {
        HkNotice,
        LiveList
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters(['liveList']),
        getGroupData() {
            const { liveList } = this;
            const groupData = {};
            liveList.forEach((item) => {
                const showTime = moment(item.show_time);
                const key = showTime.format('yyyy年MM月');
                const value = groupData[key];
                if (!value) {
                    groupData[key] = [];
                }
                groupData[key].push(item);
            });
            return Reflect.ownKeys(groupData).map((key) => ({ label: key, value: groupData[key] }));
        }
    },
    created() {
        this.$store.dispatch('queryLiveList');
    },
    mounted() {},
    methods: {
        week(time) {
            return moment(time).format('ddd');
        }
    }
};
</script>
<style lang="scss" scoped>
.live-list {
    box-sizing: border-box;
    width: 960px;
}
.no-lesson {
    width: 100%;
    height: 100%;
    margin-top: 100px;
    &-text {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333;
    }
}
</style>
